export default __webpack_public_path__ + "static/media/FurnitureItem9.33c661ec.png";